import { useTheme } from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';
import { ReactSelectInput } from '@hivebrite/design-system/Inputs';
import { useBreakpoint } from '@hivebrite/design-system/Theme';

import Grid, { Col, Row } from 'hb-react/shared/components/DesignSystem/Grid';
import useOutboxedFontTheme from 'hb-react/shared/hooks/theme/useOutboxedFontTheme';
import ThemeProvider from 'hb-react/style/ThemeProvider';

// Only goes into effect when the TitleList is so large that the sort must be moved below it
const VERTICAL_SPACING = 2;

const TitleBlock = ({
  sortBy,
  value,
  onChange,
  blockId,
  width = '152px',
  ...rest
}) => {
  const theme = useTheme();
  const outboxedFontTheme = useOutboxedFontTheme();

  if (!sortBy) {
    return (
      <ThemeProvider
        theme={outboxedFontTheme.themeName}
        fontBrightness={outboxedFontTheme.fontBrightness}
      >
        <Box display="block">
          <TitleList sortBy={sortBy} {...rest} />
        </Box>
      </ThemeProvider>
    );
  }

  return (
    <ThemeProvider
      theme={outboxedFontTheme.themeName}
      fontBrightness={outboxedFontTheme.fontBrightness}
    >
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="flex-start"
        flexWrap="wrap"
        marginBottom={`-${theme.space[VERTICAL_SPACING]}px`}
      >
        <TitleList sortBy={sortBy} {...rest} />
        <Box alignItems="center" justifyContent="flex-end" flex="1 1 auto">
          <Box
            as="label"
            htmlFor={`sort_by_${blockId}-input`}
            font="body-semibold-asphalt"
            mr={2}
          >
            {__('Sort by:')}
          </Box>
          <Box display="block">
            <ReactSelectInput
              id={`sort_by_${blockId}`}
              name="sort_by"
              options={sortBy}
              width={width}
              onChange={onChange}
              value={value}
              variant="small"
              isSearchable={false}
            />
          </Box>
        </Box>
      </Box>
    </ThemeProvider>
  );
};

const TitleList = ({
  sortBy,
  isLoading,
  itemsSize,
  title: Title,
  titleAs = 'h2',
  titleRight: TitleRight,
}) => {
  const breakpoint = useBreakpoint();

  return (
    <Grid mx={0} pb={sortBy ? VERTICAL_SPACING : 0}>
      <Row flexDirection={breakpoint === 's' && 'column-reverse'}>
        <Col>
          <Box as={titleAs} font="h2-semibold">
            {typeof Title === 'string' ? (
              Title
            ) : (
              <Title isLoading={isLoading} itemsSize={itemsSize} />
            )}
          </Box>
        </Col>
        {TitleRight && (
          <Col>
            <Box justifyContent={{ _: 'flex-start', m: 'flex-end' }}>
              {typeof TitleRight === 'string' ? TitleRight : <TitleRight />}
            </Box>
          </Col>
        )}
      </Row>
    </Grid>
  );
};

export default TitleBlock;
